<template>
  <div>
    <label class="field_label">{{ current_champ.label }} <span class="text-red"
        v-if="current_champ.mandatory == 1">*</span></label>
    <v-text-field v-model="current_champ.value" ref="field" @blur="$refs.field.validate()"
      :disabled="current_champ.disabled || is_disable"
      :rules="[$formRules.userInput(current_champ, inscription.list_courses, inscription.list_packs_courses, mode)]"></v-text-field>
    <v-snackbar v-model="snackbar_success" timeout="6000">
      <div>{{ snackbar_message }}</div>

      <template v-slot:actions>
        <v-btn color="green-darken-1" variant="elevated" @click="snackbar_success = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-model="snackbar_error" timeout="6000">
      <div>{{ snackbar_message }}</div>

      <template v-slot:actions>
        <v-btn color="red-darken-1" variant="elevated" @click="snackbar_error = false"> Fermer </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: ["champ", "inscription", "mode", "is_disable"],
  data() {
    return {
      current_champ: {},
      snackbar_success: false,
      snackbar_error: false,
      snackbar_message: "",
    };
  },


  watch: {
    champ: {
      deep: true,
      async handler() {
        this.current_champ = this.champ;
        this.$forceUpdate();
        await this.verify_licence_on_webservice();
      },
    },

    "inscription.coureur.champs.nom": {
      deep: true,
      async handler() {

        await this.verify_licence_on_webservice();
      },
    },
    "inscription.coureur.champs.prenom": {
      deep: true,
      async handler() {
        await this.verify_licence_on_webservice();
      },
    },
    "inscription.coureur.champs.sexe": {
      deep: true,
      async handler() {
        await this.verify_licence_on_webservice();
      },
    },
    "inscription.coureur.champs.date_naissance": {
      deep: true,
      async handler() {
        await this.verify_licence_on_webservice();
      },
    },
    "inscription.coureur.champs.type_inscription_ffr": {
      deep: true,
      async handler() {
        await this.verify_licence_on_webservice();
      },
    },
  },

  methods: {
    async verify_licence_on_webservice() {
      this.inscription.coureur.unvalidate_document();
      if(!this.current_champ.is_valid_num_licence_FFR()) return;
      let numero_licence_field = "numero_licence_ffr";
      let should_call_webservice = false;
      if(this.current_champ.nom == 'numero_licence_ffr_competition') {
        numero_licence_field = "numero_licence_ffr_competition";
        should_call_webservice = true;
      }
      if(this.current_champ.nom == 'numero_licence_ffr') {
        if(this.inscription.coureur.champs.type_inscription_ffr && this.inscription.coureur.champs.type_inscription_ffr.value == 'Licencié compétition FFRandonnée') {
          should_call_webservice = true;
        }
      }

      if(!should_call_webservice) return;
  

      
        this.snackbar_message = "";
        let response = await this.inscription.coureur.try_fetch_ffr_webservice(numero_licence_field);
        if (!response) {
          this.snackbar_message = "Une erreur est survenue lors de la vérification de votre licence FFR";
          this.snackbar_error = true;
          this.current_champ.value = "";
          return;
        }

        if (!response.data.licence_exist) {
          this.snackbar_message = "Ce numéro de licence n'existe pas";
          this.snackbar_error = true;
          this.current_champ.value = "";
          return;
        }

        if (!response.data.found) {
          this.snackbar_message = "Ce numéro de licence est valide mais n'est pas associé à l'identité renseignée ou ne correspond pas au type de licence sélectionné";
          this.snackbar_error = true;
          this.current_champ.value = "";
          return;
        }
        if (response.data.found && !response.data.valid) {
          this.snackbar_message = "Votre licence FFRP Hors compétition est valide";
          this.snackbar_success = true;
          return;
        }
        if (response.data.found && response.data.valid) {
          this.snackbar_message = "Votre inscription a bien été validée par votre licence FFRP compétition";
          this.snackbar_success = true;
          this.inscription.coureur.validate_document();
          return;
        }

      
 
    },
  },

  created() {
    this.current_champ = this.champ;
  },
};
</script>

<style lang="scss" scoped></style>